import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { navigateToManualServiceRecordCreate } from '../utils/serviceRecordCreateNavigation';
import { fetchApPanelOzet } from '../services/apPanelOzetService';
import AnketDavetBanner from '../components/AnketDavetBanner';
import './HomePage.css';

const YENILE_MS = 60000;

const BEDEL_DURUM = {
  OnayBekliyor: 'Onay bekliyor',
  Onaylandi: 'Onaylandı',
  HakediseAktarildi: 'Hakedişe aktarıldı',
  IptalEdildi: 'İptal',
};

const SK_DAGILIM = [
  { key: 'Ariza', etiket: 'Arıza', ton: 'ariza' },
  { key: 'Kurulum', etiket: 'Kurulum', ton: 'kurulum' },
  { key: 'Bakim', etiket: 'Bakım', ton: 'bakim' },
  { key: 'Istek', etiket: 'İstek', ton: 'istek' },
];

const dikkatTon = (etiket = '') => {
  const e = String(etiket).toLowerCase();
  if (e.includes('bedel') || e.includes('fatura')) return 'amber';
  if (e.includes('şikayet') || e.includes('onay')) return 'kirmizi';
  if (e.includes('kargo') || e.includes('değişim')) return 'mor';
  return 'mavi';
};

const sayi = (n) => Number(n || 0).toLocaleString('tr-TR');

const yuzde = (parca, toplam) => (toplam > 0 ? Math.round((parca / toplam) * 100) : 0);

const bugunBaslik = () =>
  new Date().toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });

const tarihSaat = (isoStr) => {
  if (!isoStr) return '—';
  const d = new Date(isoStr);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('tr-TR', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const randevuTarihSaat = (isoStr, saat) => {
  if (!isoStr && !saat) return '—';
  if (isoStr) {
    const d = new Date(isoStr);
    if (!Number.isNaN(d.getTime())) {
      const gun = d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
      return saat ? `${gun} ${saat}` : gun;
    }
  }
  return saat || '—';
};

const para = (n) =>
  `₺${Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const hedefHref = (path, query) => {
  if (!path) return '';
  if (!query || typeof query !== 'object') return path;
  const params = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (v != null && String(v).trim() !== '') params.set(k, String(v).trim());
  });
  const s = params.toString();
  return s ? `${path}?${s}` : path;
};

const TechServiceHome = ({ navigate }) => {
  const cards = [
    {
      title: 'Randevular',
      description: 'Randevularınızı görüntüleyin ve yönetin',
      icon: 'fas fa-calendar-alt',
      path: '/appointments',
      color: '#10b981',
    },
    {
      title: 'Off - Çalışma Saatleri',
      description: 'Çalışma saatlerinizi ayarlayın',
      icon: 'fas fa-user-clock',
      path: '/technician-availability',
      color: '#f59e0b',
    },
  ];

  return (
    <main className="main-content">
      <div className="content-header">
        <h1>Kontrol Paneli</h1>
      </div>
      <AnketDavetBanner />
      <div className="dashboard-container">
        <div className="dashboard-section">
          <div className="section-header">
            <i className="fas fa-clipboard-list"></i>
            <h2>Servis İşlemleri</h2>
          </div>
          <div className="section-divider"></div>
          <div className="cards-grid">
            {cards.map((card) => (
              <button
                key={card.path}
                type="button"
                className="dashboard-card"
                onClick={() => navigate(card.path)}
                style={{ '--card-color': card.color }}
              >
                <div className="card-icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <div className="card-content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
                <div className="card-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

const KpiKart = ({ etiket, deger, alt, onClick, ton, ikon }) => {
  const icerik = (
    <>
      <div className="ap-kpi-ikon" aria-hidden>
        <i className={`fas fa-${ikon}`} />
      </div>
      <div className="ap-kpi-govde">
        <span className="ap-kpi-deger">{deger}</span>
        <span className="ap-kpi-etiket">{etiket}</span>
        {alt ? <span className="ap-kpi-alt">{alt}</span> : null}
      </div>
    </>
  );
  const cls = `ap-kpi${onClick ? ' ap-kpi--btn' : ''}`;
  if (onClick) {
    return (
      <button type="button" className={cls} data-ton={ton} onClick={onClick}>
        {icerik}
      </button>
    );
  }
  return <div className={cls} data-ton={ton}>{icerik}</div>;
};

const SonListeKart = ({ baslik, tumuHref, onTumu, satirlar, bos, renderSatir, ton }) => (
  <section className="ap-feed" data-ton={ton}>
    <div className="ap-feed-head">
      <h3>{baslik}</h3>
      {tumuHref || onTumu ? (
        <button type="button" className="ap-feed-tumu" onClick={onTumu}>
          Tümü
        </button>
      ) : null}
    </div>
    {satirlar.length === 0 ? (
      <p className="ap-feed-bos">{bos}</p>
    ) : (
      <ul className="ap-feed-list">
        {satirlar.map((row) => (
          <li key={row.id}>{renderSatir(row)}</li>
        ))}
      </ul>
    )}
  </section>
);

const ApPanelHome = ({ user, navigate }) => {
  const isAdmin = user?.rol === 'admin';
  const isAdminOrMod = isAdmin || user?.rol === 'mod' || user?.rol === 'moderator';
  const [veri, setVeri] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [saat, setSaat] = useState(() => new Date());
  const ilkRef = useRef(true);

  const yukle = useCallback(async (sessiz = false) => {
    if (!sessiz) setYukleniyor(true);
    setHata('');
    try {
      const r = await fetchApPanelOzet();
      if (r?.basarili) {
        setVeri(r.veri);
      } else {
        setHata(r?.mesaj || 'Özet alınamadı');
      }
    } catch (err) {
      setHata(err?.message || 'Özet alınamadı');
    } finally {
      setYukleniyor(false);
      ilkRef.current = false;
    }
  }, []);

  useEffect(() => {
    yukle();
  }, [yukle]);

  useEffect(() => {
    const t = setInterval(() => yukle(true), YENILE_MS);
    return () => clearInterval(t);
  }, [yukle]);

  useEffect(() => {
    const t = setInterval(() => setSaat(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  const bugun = veri?.bugun || {};
  const cagri = bugun.cagri || {};
  const sk = bugun.servisKaydi || { toplam: 0, dagilim: {} };
  const randevu = bugun.randevu || { toplam: 0 };
  const gorusme = bugun.gorusme || { toplam: 0, skOlusturuldu: 0 };
  const dikkat = Array.isArray(bugun.dikkat) ? bugun.dikkat : [];
  const dikkatToplam = dikkat.reduce((a, b) => a + (Number(b.sayi) || 0), 0);
  const son = veri?.son || {};
  const sonSk = Array.isArray(son.servisKayitlari) ? son.servisKayitlari : [];
  const sonRandevu = Array.isArray(son.randevular) ? son.randevular : [];
  const sonBedel = isAdmin && Array.isArray(son.randevuBedelleri) ? son.randevuBedelleri : [];

  const dagilimToplam = useMemo(
    () => SK_DAGILIM.reduce((a, d) => a + (Number(sk.dagilim?.[d.key]) || 0), 0),
    [sk.dagilim]
  );

  const git = (path) => {
    if (!path) return;
    navigate(path);
  };

  return (
    <main className="main-content ap-home">
      <div className="ap-top">
        <div className="ap-top-sol">
          <h1>Bugün · {bugunBaslik()}</h1>
          <span className="ap-live">
            <i className="fas fa-circle" aria-hidden />
            Canlı · {saat.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
        <div className="ap-serit">
          <button
            type="button"
            className="ap-serit-btn"
            onClick={() => navigateToManualServiceRecordCreate(navigate)}
          >
            Servis kaydı oluştur
          </button>
          <button type="button" className="ap-serit-btn ap-serit-btn--ikincil" onClick={() => git('/cihaz-sorgulama')}>
            Cihaz sorgula
          </button>
        </div>
      </div>

      {hata ? (
        <div className="ap-hata">
          <span>{hata}</span>
          <button type="button" onClick={() => yukle()}>Yenile</button>
        </div>
      ) : null}

      {yukleniyor && ilkRef.current ? (
        <div className="ap-iskelet" aria-busy="true">
          <div className="ap-kpi-grid">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="ap-kpi ap-kpi--iskelet" />
            ))}
          </div>
        </div>
      ) : (
        <>
          <div className="ap-kpi-grid">
            <KpiKart
              etiket="Gelen çağrı"
              deger={sayi(cagri.gelen)}
              alt={`${sayi(cagri.cevapsiz)} cevapsız`}
              ton="gelen"
              ikon="phone-volume"
              onClick={isAdmin ? () => git('/musteri-hizmetleri') : undefined}
            />
            <KpiKart
              etiket="Cevap"
              deger={`%${yuzde(cagri.cevaplandi, cagri.gelen)}`}
              alt={`${sayi(cagri.cevaplandi)} cevaplandı`}
              ton="cevap"
              ikon="phone"
              onClick={isAdmin ? () => git('/musteri-hizmetleri') : undefined}
            />
            <KpiKart
              etiket="Açılan SK"
              deger={sayi(sk.toplam)}
              ton="sk"
              ikon="clipboard-list"
              onClick={() => git('/service-records')}
            />
            <KpiKart
              etiket="Bugünkü randevu"
              deger={sayi(randevu.toplam)}
              ton="randevu"
              ikon="calendar-check"
              onClick={isAdminOrMod ? () => git('/completed-appointments') : undefined}
            />
            <KpiKart
              etiket="Dikkat"
              deger={sayi(dikkatToplam)}
              ton="dikkat"
              ikon="bell"
              onClick={() => git('/bekleyen-islemler')}
            />
          </div>

          <div className="ap-orta">
            <section className="ap-kart" data-ton="dikkat">
              <div className="ap-kart-head">
                <h2>Dikkat</h2>
                <button type="button" className="ap-feed-tumu" onClick={() => git('/bekleyen-islemler')}>
                  Tümü
                </button>
              </div>
              {dikkat.length === 0 ? (
                <p className="ap-feed-bos">Bekleyen yok</p>
              ) : (
                <ul className="ap-dikkat-list">
                  {dikkat.map((k) => (
                    <li key={`${k.path}-${k.etiket}`}>
                      <button
                        type="button"
                        className="ap-dikkat-satir"
                        data-ton={dikkatTon(k.etiket)}
                        onClick={() => git(hedefHref(k.path, k.query))}
                      >
                        <span>{k.etiket}</span>
                        <span className="ap-dikkat-sayi">{sayi(k.sayi)}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </section>

            <section className="ap-kart" data-ton="dagilim">
              <div className="ap-kart-head">
                <h2>Bugünün dağılımı</h2>
              </div>
              <div className="ap-dagilim">
                {SK_DAGILIM.map((d) => {
                  const n = Number(sk.dagilim?.[d.key]) || 0;
                  const w = dagilimToplam > 0 ? Math.round((n / dagilimToplam) * 100) : 0;
                  return (
                    <div key={d.key} className="ap-dagilim-satir" data-ton={d.ton}>
                      <div className="ap-dagilim-ust">
                        <span>{d.etiket}</span>
                        <span>{sayi(n)}</span>
                      </div>
                      <div className="ap-dagilim-bar" aria-hidden>
                        <span style={{ width: `${w}%` }} />
                      </div>
                    </div>
                  );
                })}
              </div>
              <p className="ap-donusum">
                Görüşme → SK {sayi(gorusme.skOlusturuldu)}/{sayi(gorusme.toplam)}
              </p>
            </section>
          </div>

          <div className={`ap-feed-grid${isAdmin ? '' : ' ap-feed-grid--2'}`}>
            <SonListeKart
              baslik="Son servis kayıtları"
              ton="sk"
              onTumu={() => git('/service-records')}
              satirlar={sonSk}
              bos="Kayıt yok"
              renderSatir={(row) => (
                <button
                  type="button"
                  className="ap-feed-satir"
                  onClick={() => git(`/service-records/${row.id}/update`)}
                >
                  <span className="ap-feed-ana">
                    <strong>{row.numara || '—'}</strong>
                    <span>{row.musteriAdi || '—'}</span>
                  </span>
                  <span className="ap-feed-meta">
                    {row.islemTipi || '—'} · {row.durum || '—'} · {tarihSaat(row.tarih)}
                  </span>
                </button>
              )}
            />
            <SonListeKart
              baslik="Son randevular"
              ton="randevu"
              onTumu={isAdminOrMod ? () => git('/completed-appointments') : undefined}
              satirlar={sonRandevu}
              bos="Randevu yok"
              renderSatir={(row) => {
                const href =
                  row.servisKaydiId && row.id
                    ? `/service-records/${row.servisKaydiId}/appointments/${row.id}`
                    : null;
                return (
                  <button
                    type="button"
                    className="ap-feed-satir"
                    disabled={!href}
                    onClick={() => href && git(href)}
                  >
                    <span className="ap-feed-ana">
                      <strong>{row.musteriAdi || row.numara || '—'}</strong>
                      <span>{row.teknikServisAdi || '—'}</span>
                    </span>
                    <span className="ap-feed-meta">
                      {randevuTarihSaat(row.randevuTarihi, row.randevuSaati)} · {row.durum || '—'}
                    </span>
                  </button>
                );
              }}
            />
            {isAdmin ? (
              <SonListeKart
                baslik="Son randevu bedelleri"
                ton="bedel"
                onTumu={() => git('/randevu-bedelleri')}
                satirlar={sonBedel}
                bos="Bedel yok"
                renderSatir={(row) => {
                  const href =
                    row.servisKaydiId && row.randevuId
                      ? `/service-records/${row.servisKaydiId}/appointments/${row.randevuId}`
                      : '/randevu-bedelleri';
                  return (
                    <button type="button" className="ap-feed-satir" onClick={() => git(href)}>
                      <span className="ap-feed-ana">
                        <strong>{row.randevuNumarasi || '—'}</strong>
                        <span>{para(row.toplamTutar)}</span>
                      </span>
                      <span className="ap-feed-meta">
                        {row.teknikServisAdi || '—'} · {BEDEL_DURUM[row.durum] || row.durum || '—'}
                      </span>
                    </button>
                  );
                }}
              />
            ) : null}
          </div>
        </>
      )}
    </main>
  );
};

const HomePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const userRole = user?.rol?.toLowerCase?.() || user?.rol || '';
  const isTechService =
    userRole === 'tech-service' ||
    userRole === 'teknikservis' ||
    userRole === 'techservice' ||
    userRole === 'teknik-servis' ||
    user?.rol === 'tech-service' ||
    user?.rol === 'teknikServis' ||
    user?.rol === 'techService';

  if (isTechService) {
    return <TechServiceHome navigate={navigate} />;
  }

  return <ApPanelHome user={user} navigate={navigate} />;
};

export default HomePage;
